import Layout from '../../components/Layout';
import InquiriesForm from './InquiriesForm';
import InfoLinks from './InfoLinks';
import * as styles from './styles.module.css';

const Inquiries = () => (
  <Layout pageTitle="Inquiries - FabFitFun">
    <div className={styles.page}>
      <div className={styles.content}>
        <section className={styles.inquiries}>
          <h1 className={styles['inquiries__h1']}>Inquiries</h1>
          <InfoLinks />
          <h2 className={styles['inquiries__h2']}>
            Sponsorship, Non-Profit, and Manufacturer Partnerships
          </h2>
          <p>
            Have an amazing company or product and want to work with us? Know of a great brand we
            should work with? Please fill out the following form.
          </p>
          <InquiriesForm />
        </section>
      </div>
    </div>
  </Layout>
);

export default Inquiries;
